import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=3550ec37"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports